(() => {
  if (window.mgrPurchaseAccordionLoaded) return;
  window.mgrPurchaseAccordionLoaded = true;
  const config = window.mgrPurchaseAccordion;
  if (!config) return;
  const paths = {
    time: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    shipping: '<path d="M3 6h11v11H3zM14 10h4l3 4v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
    terms: '<path d="M8 4H5v17h14V4h-3M9 3h6v4H9zM8 12l2 2 5-5M8 18h8"/>'
  };
  const items = [
    { id: '30158', title: config.fabrication, icon: 'time' },
    { id: '998725', title: config.shipping, icon: 'shipping' },
    { id: '653583', title: config.terms, icon: 'terms' }
  ];
  function update(field) {
    const input = field.querySelector('input[type="checkbox"]');
    const status = field.querySelector('.mgr-purchase-status');
    if (!input || !status) return;
    const accepted = input.checked;
    field.dataset.mgrAccepted = accepted ? 'true' : 'false';
    const value = (accepted ? '✓ ' : '') + (accepted ? config.accepted : config.pending);
    if (status.textContent !== value) status.textContent = value;
  }
  function open(field, value) {
    field.dataset.mgrOpen = value ? 'true' : 'false';
    const button = field.querySelector('.mgr-purchase-toggle');
    if (button) button.setAttribute('aria-expanded', String(value));
  }
  function enhance() {
    document.querySelectorAll('.tcustomizer-field--Description[class*="tcustomizer-field-477792-"]').forEach(field => {
      const paragraph = field.querySelector('p');
      if (!paragraph || paragraph.querySelector('.mgr-custom-quote-phone')) return;
      paragraph.textContent = config.contact + ' ';
      const link = document.createElement('a');
      link.className = 'mgr-custom-quote-phone';
      link.href = 'https://wa.me/56945007501';
      link.textContent = '+56 9 4500 7501';
      paragraph.appendChild(link);
    });
    items.forEach(item => {
      document.querySelectorAll('.tcustomizer-field[id^="tcustomizer-field-' + item.id + '-"]').forEach(field => {
        const heading = field.querySelector('.tcustomizer-field__heading');
        const panel = field.querySelector('.tcustomizer-field__input');
        const input = field.querySelector('input[type="checkbox"]');
        if (!heading || !panel || !input) return;
        if (item.icon === 'shipping' && !heading.querySelector('.mgr-santiago-shipping')) {
          const note = document.createElement('span');
          note.className = 'mgr-santiago-shipping';
          note.style.display = 'block';
          note.style.marginBottom = '8px';
          note.textContent = 'Si eres de Santiago, el valor del envío a tu comuna se mostrará al finalizar la compra.';
          heading.prepend(note);
        }
        if (!field.querySelector('.mgr-purchase-toggle')) {
          heading.id = field.id + '-information';
          panel.id = field.id + '-acceptance';
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mgr-purchase-toggle';
          button.setAttribute('aria-controls', heading.id + ' ' + panel.id);
          button.innerHTML = '<svg class="mgr-purchase-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths[item.icon] + '</svg><span class="mgr-purchase-title"></span><span class="mgr-purchase-status"></span><svg class="mgr-purchase-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
          button.querySelector('.mgr-purchase-title').textContent = item.title;
          field.insertBefore(button, heading);
          field.classList.add('mgr-purchase-block');
          open(field, false);
          button.addEventListener('click', () => open(field, field.dataset.mgrOpen !== 'true'));
          field.addEventListener('change', () => update(field));
          field.addEventListener('focusin', event => {
            if (!event.target.closest('.mgr-purchase-toggle')) open(field, true);
          });
        }
        update(field);
      });
    });
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('#tcustomizer-add, .enj-add-to-cart-btn, .shopify-payment-button__button');
    if (!button) return;
    const form = button.closest('form');
    if (!form) return;
    Array.from(form.querySelectorAll('[data-mgr-open]')).forEach(field => {
      const input = field.querySelector('input[type="checkbox"]');
      if (input && !input.checked) open(field, true);
    });
  }, true);
  document.addEventListener('invalid', event => {
    const field = event.target.closest && event.target.closest('[data-mgr-open]');
    if (field) open(field, true);
  }, true);
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  }).observe(document.body, { childList: true, subtree: true });
  enhance();
})();
